import { wait } from "./wait";

export const delayPromiseAtLeast = async <T>(
  promise: Promise<T>,
  time: number,
) => {
  const [result] = await Promise.all([promise, wait(time)]);
  return result;
};
